import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { ItemMenu } from "../../components/UI/ItemMenu";
import { useHistory, createSearchParams, useLocation } from "react-router-dom";
import { GetWindowState, defaultReducer, usePageState, useQuery } from "../../Utils";
import { translate } from "react-i18nify";
import { colors } from "../../Style";

export const BlindVitalValues = (props) => {
    const history = useHistory();
    const location = useLocation();
    const state = GetWindowState();

    const generateMenuItems = (state) => {
            return [
                {
                    label: "Spo2",
                    value: props.pro?.vitalVis.Spo2 ? "SHOWN" : "HIDDEN",
                },
                {
                    label: "Pulse",
                    value: props.pro?.vitalVis.Pulse ? "SHOWN" : "HIDDEN",
                },
                {
                    label: "O2Flow",
                    value: props.pro?.vitalVis.O2Flow ? "SHOWN" : "HIDDEN",
                },
            ];
        }

    const navigation = (navigatior, action, menu, state) => {
        if(action.type === "CLICK"){
            switch(menu[action.button].route){
        case "NAVIGATE_BACK":
            props.onCancel();
            break;
        case "NAVIGATE_SELECT":
            selectClicked(state)
            break;
        case "NAVIGATE_UP":
            valueUp(state);
            break;
        case "NAVIGATE_DOWN":
            valueDown(state);
            break;
            }
        }
    }

    const [pageState, setPageState] = usePageState(
        defaultReducer,
        state
            ? state
            : {
                menu: {
                    LEFT: { label: "Back", route: "admin" },
                    UP: null,
                    RIGHT: { label: "Select", route: "NAVIGATE_SELECT", local: true },
                    MIDDLE: null,
                    DOWN: { label: "DOWN", route: "NAVIGATE_DOWN", local: true },
                },
                window: null,
                activeItemIndex: 0,
                menuItems: generateMenuItems(state),
            }
    );

    const defaultState = {
        name: props.name,
        value: props.value,
        activeItemIndex: 0,
        label: props.label,
        menuItems: generateMenuItems(state),
        windowNavigation: navigation,
    };

    const setWindowState = (windowState) => {
        props.setState(windowState.menu, windowState);
    };

    const menu = props.menu
        ? props.menu
        : {
            LEFT: { label: "Back", route: "NAVIGATE_BACK", local: true },
            UP: defaultState.modifyNavigation
                ? { label: "UP", route: "VALUE_UP", local: true }
                : null,
            RIGHT: { label: "Select", route: "NAVIGATE_SELECT", local: true },
            MIDDLE: null,
            DOWN: { label: "DOWN", route: "NAVIGATE_DOWN", local: true },
        };

    const windowState = props?.state
        ? {
            ...props.state,
            menu: menu,
            label: props.label,
        }
        : defaultState;


	const valueUp = (state) => {
		let prevIndex = state.activeItemIndex;
		let newActiveIndex = prevIndex > 0 ? prevIndex - 1 : prevIndex;
		let newState = { ...state, activeItemIndex: newActiveIndex };
		setWindowState({
			...state,
			activeItemIndex: newActiveIndex,
			menu: updateNavigation(newState),
		});
	
	};

	const valueDown = (state) => {
		let prevIndex = state.activeItemIndex;
		let menuItems = state.menuItems;
		let newActiveIndex =
			prevIndex < menuItems.length - 1 ? prevIndex + 1 : prevIndex;
		let newState = { ...state, activeItemIndex: newActiveIndex };
		setWindowState({
			...state,
			activeItemIndex: newActiveIndex,
			menu: updateNavigation(newState),
		});
	};

    const selectClicked = (state) => {
        props.pro?.setVitalVis(state.menuItems[state.activeItemIndex].label)
    }
        
	const updateNavigation = (state) => {
		let menu = {
			LEFT: { label: "Back", route: "NAVIGATE_BACK", local: true },
			RIGHT: { label: "Select", route: "NAVIGATE_SELECT", local: true },
		};
		const showUpButton = state.activeItemIndex > 0;
		const showDownButton = state.activeItemIndex < state.menuItems.length - 1;
		menu.UP = showUpButton
			? { label: "UP", route: "NAVIGATE_UP", local: true }
			: null;
		menu.DOWN = showDownButton
			? { label: "DOWN", route: "NAVIGATE_DOWN", local: true }
			: null;
		return menu;
	};

    useEffect(() => {
        windowState.windowNavigation = navigation;
        props.setState(menu, windowState);
    }, [windowState.name]);

    return (
        <Box
            sx={{
                width: "325px",
                height: "90px",
                background: "black",
                border: "1px solid white",
                p: 1,
                pl: 2,
                pr: 2,
            }}
        >
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <Typography
                    variant="h6"
                    sx={{ color: colors().TEXT_COLOR, fontWeight: "bold" }}
                >
                    {windowState?.label}
                </Typography>
            </Box>
            <ItemMenu
                activeItemIndex={windowState.activeItemIndex}
                // selected={windowState.editMode === EDIT_MODE.MODE_EDIT_VALUE}
                menuItems={generateMenuItems(state)}
              />
        </Box>
    );
}
        
